var exports = {
  "MJ": "FormControl__WAcAXi",
  "ks": "TextInput__Rn-CNz",
  "EY": "Text__Pczda4",
};

module.exports = exports;
